export default __webpack_public_path__ + "static/media/Snd4.9fa20213.mp3";